import type { ProductMenuDef } from '../type.js';

/** Tabula (リソーステーブル) のメニュー定義。 */
export const QANT_TABULA_MENU = {
  product: {
    name: 'tabula',
    icon: 'qantTabula',
    label: { ja: 'リソーステーブル', en: 'Resource Table' },
    description: { ja: '表形式データの管理', en: 'Resource table management' },
  },
  menuGroups: {
    BASIC: {
      name: 'basic',
      menus: {
        TABLES: {
          name: 'tables',
          icon: 'tableDefinition',
          label: { ja: 'リソーステーブル', en: 'Resource Table' },
          path: { host: 'qant', path: '/tabula/tables' },
        },
      },
    },
  },
} as const satisfies ProductMenuDef;
